import { render, staticRenderFns } from "./GenerlInfoView.vue?vue&type=template&id=be5d73e0&scoped=true"
import script from "./GenerlInfoView.vue?vue&type=script&lang=js"
export * from "./GenerlInfoView.vue?vue&type=script&lang=js"
import style0 from "./GenerlInfoView.vue?vue&type=style&index=0&id=be5d73e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5d73e0",
  null
  
)

export default component.exports